<template>
  <require from="./app.css"></require>
  <require from="framework/html_behaviors/af-progress.html"></require>
  <require from="controls/bs-toast-list"></require>

  <router-view></router-view>
  <div class="application-alert"><bs-toast-list></bs-toast-list></div>
  <af-progress block.bind="blockMouse" indicate.bind="showIndicator"></af-progress>
</template>
